/** @format */

import { PurchaseWarranty } from '@dsg-tech/non-merch-common-externals';
import { Addon } from '../cart-checkout/addons.interface';
import { Warranty } from '../warranty.interface';
import { Attribute } from './attribute.interface';

export interface CartItem {
  analytics: CartItemAnalytics;
  attributes: Map<string, Attribute>;
  bopis_store?: string;
  description: string[];
  ecode: string;
  external_key: string;
  gtgtEligible?: boolean;
  images: string[];
  list_price: number;
  manufacturer: string;
  my_customizer?: CustomCartItem;
  pdp_template?: PDPTemplate;
  procure?: string;
  quantity: number;
  sku: string;
  total_unit_price?: string;
  unit_price: number;
  addons?: Addon[];
  availableWarranties?: Warranty[];
  purchaseWarranty?: PurchaseWarranty;
  isScoreCardPlus?: boolean;
}

export interface CartItemAnalytics {
  item_discount: number;
  order_discount: number;
  shipping_discount: number;
  shipping_paid: number;
  tax_paid: number;
}

export enum PDPTemplate {
  Launch = 'isLaunch',
  SecureLaunch = 'isSecureLaunch',
}

export interface CustomCartItem {
  custom_product_image: string;
  design_id: string;
}
